var _style, _polygon, _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReloj(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FA405C;}\n\t.st1{fill:#5A1372;}\n\t.st2{fill:#E9DCFF;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "250.8,101.4 226.4,555.4 360.3,954.4 663.5,910.4 649.8,477.9 520.9,62.2 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M666.4,930.6l-303.2,43.9c-9.6,1.2-18.6-4.6-21.6-13.8L207.3,561.9c-0.8-2.4-1.1-5-1-7.5l24-453.9 c0.5-9.6,7.7-17.4,17.2-18.8L518,42.3c9.8-1.5,19.2,4.5,22.1,13.9L669,472c0.5,1.7,0.8,3.5,0.9,5.4l13.7,432.4 C684.1,920.1,676.6,929.1,666.4,930.6z M374.1,932.3l268.7-39l-13.1-411.8l-123-396.9L270.1,119l-23.3,433.7L374.1,932.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 450.5,
    cy: 525.3,
    r: 271.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M491.9,814.4C331.6,837.9,182.6,727,159.1,566.6c-23.5-160.3,87.5-309.3,247.8-332.8s309.3,87.5,332.8,247.8 c19.6,133.9-54.9,263.8-180.4,314.5C537.7,804.8,515,811,491.9,814.4z M414.8,276.1c-19.9,3-39.4,8.4-58.1,16 c-127.6,52.5-188.5,198.4-136,326c52.5,127.6,198.4,188.5,326,136c127.6-52.5,188.5-198.4,136-326 C639,321.8,528.5,259.1,414.8,276.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M590.1,621.5c-3.1,0.4-6.2-0.2-8.8-1.8l-139.4-86.7c-5.4-3.4-7.5-10.2-5-16L485,409c2.9-6.6,10.7-9.7,17.3-6.7 c6.6,2.9,9.7,10.7,6.7,17.3l0,0L466,517.2l129.5,80.7c6.1,3.8,8,11.8,4.2,18C597.4,619,594,621.1,590.1,621.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M427.7,333.7c7.8-1.1,13.2-8.3,12-16.1c-1.1-7.8-8.3-13.2-16.1-12l0,0c-7.8,1.1-13.2,8.3-12,16.1 C412.7,329.4,420,334.8,427.7,333.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M489,755.6c7.8-1.1,13.2-8.3,12-16.1c-1.1-7.8-8.3-13.2-16.1-12c-7.8,1.1-13.2,8.3-12,16.1 C474,751.4,481.2,756.8,489,755.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M669.3,513.8c7.8-1.1,13.2-8.3,12-16.1c-1.1-7.8-8.3-13.2-16.1-12c-7.8,1.1-13.2,8.3-12,16.1 S661.5,514.9,669.3,513.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.4,575.3c7.8-1.1,13.2-8.3,12-16.1c-1.1-7.8-8.3-13.2-16.1-12c-7.8,1.1-13.2,8.3-12,16.1 C232.4,571,239.6,576.4,247.4,575.3L247.4,575.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M427.7,333.7c7.8-1.1,13.2-8.3,12-16.1c-1.1-7.8-8.3-13.2-16.1-12l0,0c-7.8,1.1-13.2,8.3-12,16.1 C412.7,329.4,420,334.8,427.7,333.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M489,755.6c7.8-1.1,13.2-8.3,12-16.1c-1.1-7.8-8.3-13.2-16.1-12c-7.8,1.1-13.2,8.3-12,16.1 C474,751.4,481.2,756.8,489,755.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M669.3,513.8c7.8-1.1,13.2-8.3,12-16.1c-1.1-7.8-8.3-13.2-16.1-12c-7.8,1.1-13.2,8.3-12,16.1 S661.5,514.9,669.3,513.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.4,575.3c7.8-1.1,13.2-8.3,12-16.1c-1.1-7.8-8.3-13.2-16.1-12c-7.8,1.1-13.2,8.3-12,16.1 C232.4,571,239.6,576.4,247.4,575.3L247.4,575.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.6,383.6c7.8-1.1,13.2-8.3,12-16.1c-1.1-7.8-8.3-13.2-16.1-12l0,0c-7.8,1.1-13.2,8.3-12,16.1 S310.9,384.8,318.6,383.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M598.1,705.6c7.8-1.1,13.2-8.3,12-16.1c-1.1-7.8-8.3-13.2-16.1-12l0,0c-7.8,1.1-13.2,8.3-12,16.1 C583.2,701.4,590.4,706.8,598.1,705.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M619.3,404.9c7.8-1.1,13.2-8.3,12-16.1s-8.3-13.2-16.1-12l0,0c-7.8,1.1-13.2,8.3-12,16.1 C604.3,400.6,611.5,406,619.3,404.9z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.4,684.4c7.8-1.1,13.2-8.3,12-16.1c-1.1-7.8-8.3-13.2-16.1-12c-7.8,1.1-13.2,8.3-12,16.1 C282.4,680.1,289.6,685.5,297.4,684.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259.5,467.9c7.8-1.1,13.2-8.3,12-16.1c-1.1-7.8-8.3-13.2-16.1-12c-7.8,1.1-13.2,8.3-12,16.1 C244.5,463.6,251.7,469,259.5,467.9L259.5,467.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M657.2,621.4c7.8-1.1,13.2-8.3,12-16.1c-1.1-7.8-8.3-13.2-16.1-12l0,0c-7.8,1.1-13.2,8.3-12,16.1 C642.2,617.1,649.4,622.5,657.2,621.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M535.1,345.5c7.8-1.1,13.2-8.3,12-16.1c-1.1-7.8-8.3-13.2-16.1-12l0,0c-7.8,1.1-13.2,8.3-12,16.1 C520.1,341.2,527.3,346.6,535.1,345.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M381.7,743.5c7.8-1.1,13.2-8.3,12-16.1c-1.1-7.8-8.3-13.2-16.1-12l0,0c-7.8,1.1-13.2,8.3-12,16.1 C366.7,739.3,373.9,744.7,381.7,743.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloj);
export default __webpack_public_path__ + "static/media/reloj.9a20e0a159a76e658524a103ec35ec23.svg";
export { ForwardRef as ReactComponent };